export default __webpack_public_path__ + "static/media/boneco3.99acbd62.svg";